const yoigoParticular1 = [
    {
        "tipoVenta": "PORTA",
        "tipoLinea": "LINEA_ADICIONAL",
        "tarifa": {
            "id": "CONTFHD999GNTR04",
            "price": 61.157,
            "name": "Fibra 1 Gb Indirecta + La Sinfín GB Infinitos",
            "operator": "YOIGO",
            "segment": "PARTICULAR",
            "category": "convergent",
            "color": "blue",
            "commercial_enrichment": {
                "commercial_name": "FIBRA 1 Gb Indirecta + LA SINFÍN ∞ GB"
            },
            "description_file": "https://www.yoigo.com/pdf/statics/tariffs/Fibra1Gb_ind_SinFin_InfinitosGB.pdf",
            "fixed_line_info": {
                "type": "fiber",
                "price": {
                    "base_fee": 34.711
                },
                "owners": [
                    "OTHER"
                ],
                "upload_speed": {
                    "unit": "Gb",
                    "amount": 1
                },
                "download_speed": {
                    "unit": "Gb",
                    "amount": 1
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": -1
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": 60
                }
            },
            "mobile_line_info": {
                "price": {
                    "base_fee": 26.45
                },
                "mobile_line_data": {
                    "unit": "MB",
                    "amount": -1
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": -1
                }
            },
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-05-25T00:45:13.938041+02:00",
            "updated_on": "2022-05-25T00:45:13.946057+02:00",
            "svas": [
                "AGILETV_0_PREMIUMSERDDD001",
                "AGILETV_0_PREMIUMSERDDD002",
                "SMARTHOMESERDDD001"
            ],
            "promotions": [
                "PROMOYOIGO23",
                "PROMOYOIGO25",
                "PROMOYOIGO26",
                "PROMOYOIGO4",
                "PROMOYOIGO32"
            ],
            "additional_lines": [
                "CONT28",
                "CONT29",
                "PLADUO(ADICIONAL)YOIGO",
                "PLADUO(PRINCIPAL)YOIGO",
                "PLASINFIN20GBADICIONALYOIGO",
                "PLASINFIN50GBADICIONALYOIGO",
                "PLASINFINADICIONALYOIGO",
                "PLASINFINGBINFINITOSADICIONALYOIGO"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOYOIGO26",
                "duration": 3,
                "name": "Convergente 1Gb A Precio 300Mb",
                "duration_unit": "month",
                "amount": "15.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": "Valido para altas nuevas o portabilidades de fijo y movil, no aplica a pedidos crossel",
                "operator": "YOIGO"
            }
        ]
    },
    {
        "tipoVenta": null,
        "tipoLinea": "LINEA_ADICIONAL_SVA",
        "tarifa": {
            "id": "DOCTOR_GOYOIGO1",
            "price": 4.959,
            "name": "DOCTOR GO",
            "operator": "YOIGO",
            "image": null,
            "more_info": null,
            "permanence": 0,
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-05-25T00:45:13.880466+02:00",
            "updated_on": "2022-05-25T00:45:13.890811+02:00",
            "promotions": [
                "PROMOYOIGO33",
                "PROMOYOIGO19"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOYOIGO33",
                "duration": 3,
                "name": "Doctor Go 3 Meses Gratis",
                "duration_unit": "month",
                "amount": "100.00",
                "amount_unit": "PERCENTS",
                "is_active": true,
                "observations": null,
                "operator": "YOIGO"
            }
        ]
    },
    {
        "tipoVenta": null,
        "tipoLinea": "LINEA_ADICIONAL_SVA",
        "tarifa": {
            "id": "ENERGY_GOYOIGO1",
            "price": 0,
            "name": "ENERGY GO",
            "operator": "YOIGO",
            "image": null,
            "more_info": null,
            "permanence": 0,
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-05-25T00:45:13.880466+02:00",
            "updated_on": "2022-05-25T00:45:13.890811+02:00",
            "promotions": [
                "PROMOYOIGO37"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOYOIGO37",
                "duration": 0,
                "name": "-6€ DTO ENERGYGO",
                "duration_unit": "month",
                "amount": "6.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": null,
                "operator": "YOIGO"
            }
        ]
    }
]
export default yoigoParticular1;